import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function ArticleEntry() {
  const { t } = useTranslation();

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">{t("articleEntry.title")}</h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3">{t("articleEntry.subtitle")}</p>
        </div>

        <div className="max-w-3xl mx-auto rounded-lg overflow-hidden border border-background-200 bg-background-50">
          <div className="h-44 md:h-52 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20desk%20with%20an%20open%20laptop%20showing%20a%20neatly%20organized%20product%20spreadsheet%2C%20beside%20a%20cup%20of%20coffee%20and%20a%20small%20stack%20of%20folded%20neutral%20colored%20t-shirts%2C%20soft%20warm%20natural%20light%2C%20premium%20editorial%20workspace%20photography%2C%20warm%20cream%20and%20soft%20sage%20tones%2C%20high%20detail%2C%20harmonious%20composition&width=1200&height=600&seq=article-card-2026&orientation=landscape&nocache=true"
              alt="AllChinaBuy spreadsheet buyer guide — organized product data on laptop"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="p-6 md:p-8">
            <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium">
              <i className="ri-bookmark-line"></i>
              {t("articleEntry.title")}
            </span>
            <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mt-4">
              {t("articleEntry.cardTitle")}
            </h3>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mt-3">
              {t("articleEntry.cardDesc")}
            </p>
            <Link
              to="/allchinabuy-spreadsheet-guide"
              className="inline-flex items-center gap-2 mt-6 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              {t("articleEntry.readMore")}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}